var render, staticRenderFns
import script from "./formMultiple.vue?vue&type=script&lang=js&"
export * from "./formMultiple.vue?vue&type=script&lang=js&"
import style0 from "./formMultiple.vue?vue&type=style&index=0&id=1c28efb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c28efb8",
  null
  
)

export default component.exports